var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',{staticClass:"tag-list"},_vm._l((_vm.tags),function(tag,index){return _c('li',{key:index,staticClass:"tag-default tag-pill tag-outline"},[_c('span',{domProps:{"textContent":_vm._s(tag)}})])}))}
var staticRenderFns = []

export { render, staticRenderFns }